<template>
  <input type="number" class="form-control" v-model="displayValue" @blur="updateMessage" @focus="isInputActive = true" />
</template>

<script>


export default {
    name: 'input-formatted',
    props: ["value"],
    data() {
        return {
            isInputActive: false
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    // Cursor is inside the input field, unformat display value for user
                    return this.value
                } else {
                    return (isNaN(this.value)) ? parseFloat(this.value) : parseFloat(this.value).toFixed(0)
                }
            },
            set: function(modifiedValue) {
                // Recalculate value in user input
                let newValue = parseFloat(modifiedValue)
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0
                }
                // Note: we cannot set this.value as it is a "prop", it needs to be passed to parent component
                // $emit the event so that parent component gets it
                this.$emit('input', newValue)
            }
        },
    },
    methods: {
        updateMessage(e) {
            this.isInputActive = false
            this.$store.dispatch('BikeDataStore/updateInputs',  e.target);
        }   
    }
};
</script>